// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ArrowDownOutlinedSvg from "@fishx/icons-svg/es/asn/ArrowDownOutlined";
import FishxIcon from '../components/FishxIcon';

var ArrowDownOutlined = function ArrowDownOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ArrowDownOutlinedSvg
  }));
};

ArrowDownOutlined.displayName = 'ArrowDownOutlined';
export default React.forwardRef(ArrowDownOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ArrowDownOutlined.js
// module id = 2020
// module chunks = 0